import { Button, Grid, Typography } from '@mui/material';
import StyledButton from '../components/StyledButton';

const Header = () => {
  return (
    <Grid container sx={{
      width: "100%",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      background: {xs: `url('./assets/background3.jpg') no-repeat center`, md: `url('./assets/background2.jpg') no-repeat center right`},
      backgroundSize: {xs: "contain", md: "contain"},
    }}>
      <Grid item xs={12} md={6} sx={{ zIndex: "1", display: "flex", flexDirection: "column", alignItems: {xs: "center", md: "flex-start"} }}>
        <Typography variant="h4" sx={{paddingTop: "88px", marginBottom: "2rem", textAlign: {xs: "center", md: "left"} }}>
          Welcome to <Typography variant="h4" component="span" sx={{fontFamily: "Orbitron"}}>CyberBadge</Typography>
        </Typography>
        <Typography variant="subtitle1" sx={{ marginBottom: "1rem", textAlign: {xs: "center", md: "left"} }}>
        CyberBadge is an incredibly light and versatile LED display that is perfect for a wide range of events and parties
        </Typography>
        <Typography variant="subtitle1" sx={{ marginBottom: "1rem", textAlign: {xs: "center", md: "left"} }}>
        Whether you're looking to grab attention CyberBadge is designed to help you stand out from the crowd
        </Typography>
        <StyledButton
          onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          title='Contact Us'
        />
      </Grid>
      {/* <Grid item xs={12} md={6}></Grid> */}
    </Grid>
  )
}

export default Header